export const setcutomerinfo = (data) =>({
    type:'SET_CUSTOMERINFO',
    payload:data,
  })  